import axios from "axios";

// Fungeert als template voor alle API-calls
const axiosInstance = axios.create({
  baseURL: "https://iamposdev.ig-nl.com/api/",
  timeout: 5000,
  headers: {
    Authorization: "JWT " + localStorage.getItem("access_token"),
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    if (localStorage.getItem("refresh_token") === null) {
      window.location = "/app/login/";
    }

    if (error.response.status === 404) {
      window.location = "/app/not-found/";
    }

    if (
      error.response.status === 401 &&
      error.response.statusText === "Unauthorized"
    ) {
      let refresh_token = localStorage.getItem("refresh_token");

      axiosInstance
        .post("/token/refresh/", { refresh: refresh_token })
        .then((response) => {
          localStorage.setItem("access_token", response.data.access);
          localStorage.setItem("refresh_token", response.data.refresh);

          axiosInstance.defaults.headers["Authorization"] =
            "JWT " + response.data.access;
          originalRequest.defaults.headers["Authorization"] =
            "JWT " + response.defaults.headers;
          return axiosInstance;
        })
        .catch((e) => {
          window.location = window.location.href;
          console.log(e);
        });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
